var map = {
	"./Group.svg": 719,
	"./ImageBg.png": 639,
	"./Vector2.svg": 202,
	"./Vector3.svg": 927,
	"./advantages/certificate.svg": 3,
	"./advantages/clock.svg": 907,
	"./advantages/place.svg": 625,
	"./advantages/ruble.svg": 348,
	"./advantages/shield.svg": 143,
	"./advantages/way.svg": 201,
	"./arrow.svg": 421,
	"./arrowLeft.svg": 236,
	"./arrowRight.svg": 413,
	"./certificate/image1.png": 803,
	"./certificate/image2.png": 468,
	"./certificate/image3.png": 875,
	"./certificate/image4.png": 876,
	"./click.svg": 401,
	"./logo.svg": 835,
	"./oil-barrel1.svg": 49,
	"./partner/Rosneft_Logo1.png": 12,
	"./partner/Tatneft-Logo 1.png": 787,
	"./partner/gazprom.png": 770,
	"./partner/layer1.png": 204,
	"./phone.svg": 244,
	"./user.svg": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;